module.exports = __webpack_public_path__ + "static/media/meter_1.9638e40a.svg";